import Style from './style'

import useGetAccountQRGenerate from 'entity/account/useGetAccountQRGenerate'
import {QRCodeCanvas} from 'qrcode.react'
import {QR_REFRESH_TIME} from 'shared/constant/countdown'
import useCountdownRefetch from 'shared/hooks/useCountdownRefetch'
import DefaultButton from 'shared/ui/DefaultButton'
import DefaultSlideModal from 'shared/ui/DefaultSlideModal'

const QRModal = ({isOpen, closeEvent}) => {
	const [userQR, loading, refetch] = useGetAccountQRGenerate()
	// Only run countdown when modal is open and there's a valid QR code to refresh
	const shouldRunCountdown =
		isOpen && !loading && !userQR?.data?.error_code && userQR?.data?.qr_token

	// // Use countdown refetch hook
	const {countdown, handleRefetch} = useCountdownRefetch(refetch, {
		initialTime: QR_REFRESH_TIME,
		shouldRun: shouldRunCountdown,
		resetTrigger: isOpen,
	})
	return (
		<DefaultSlideModal title='내 QR 코드' closeEvent={closeEvent}>
			<Style.Content>
				<QRCodeCanvas size={250} value={userQR?.data?.qr_token} />
				<Style.QRControls>
					{shouldRunCountdown && (
						<p className='countdown-text'>Refresh in {countdown}s</p>
					)}
					<Style.RefreshButton onClick={handleRefetch}>
						Refresh now
					</Style.RefreshButton>
				</Style.QRControls>
			</Style.Content>
			<DefaultButton clickEvent={closeEvent}>닫다</DefaultButton>
		</DefaultSlideModal>
	)
}

export default QRModal
